// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import ManagedAccordionSection from "@insite/mobius/AccordionSection/ManagedAccordionSection";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
// import { StyledClickable } from "@insite/mobius/Link"; // Store Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { linkAltStyles } from "@store/Themes/common/mixins/link";
import { typographyInvertColorStyles } from "@store/Themes/common/mixins/typography";
import { accordionFooterSectionProps } from "@store/Themes/common/props/accordionFooter";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles, spacingStyles } from "@toolkit/Themes/common/mixins";

// Sas --->
import zoneElementsSelector from "@store/Framework/Common/Utilities/zoneElementsSelector";
import zoneNestedElementsSelector from "@store/Framework/Common/Utilities/zoneNestedElementsSelector";
import { IconWrapper } from "@insite/mobius/Icon/Icon";
import { StyledClickable, StyledTypography } from "@insite/mobius/Link";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";

const enum fields {
    contentTitle = "contentTitle",
    firstColumnTitle = "firstColumnTitle",
    secondColumnTitle = "secondColumnTitle",
    thirdColumnTitle = "thirdColumnTitle",
    fullWidth = "fullWidth", // Store Custom Code
}

const footerLinkStyles = () => linkAltStyles();

const footerTitleStyles = () => css`
    ${({ theme }) => css`
        ${spacingStyles(null, "0.8em")}
        font-size: ${theme.design.typography.size.large};
        font-weight: ${theme.design.typography.weight.bold};
        line-height: ${theme.design.typography.lineHeight.semi};

        ${breakpoint("sm")} {
            font-size: ${theme.design.typography.size.larger};
        }

        ${breakpoint("xl")} {
            font-size: ${theme.design.typography.size.largest};
        }
    `}
`;

const legalVerticalGap = pxToRem(8);
const legalHorizontalGap = pxToRem(16);
const legalFlexWrapperStyles = () => css`
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    flex-direction: column;
    gap: ${legalVerticalGap} ${legalHorizontalGap};
    align-items: center;
    text-align: center;

    ${breakpoint("md")} {
        flex-direction: row;
        text-align: left;
    }
`;
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
    // Starter Custom Code
    widgetWrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    wrapper?: InjectableCss;
    gridContainer?: GridContainerProps;
    columnsGridItem?: GridItemProps;
    columnsGridContainer?: GridContainerProps;
    columnGridItem?: GridItemProps;
    columnTitle?: TypographyPresentationProps;
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
    contentGridItem?: GridItemProps;
    contentTitle?: TypographyPresentationProps;
    hidden?: HiddenProps;
    separatorGridItem?: GridItemProps;
    legalWrapper?: InjectableCss;
    legalInnerWrapper?: InjectableCss;
    legalZoneGroupWrapper?: InjectableCss;
    legalZoneWrapper?: InjectableCss;
    // SasCustom
    footerContainer?: InjectableCss;
    leftGridItem?: GridItemProps;
    rightGridItem?: GridItemProps;
    bottomGridItem?: GridItemProps;
    contactWrapper?: InjectableCss;
    linkListGridItem?: GridItemProps;
}

export const footerContainerStyles: FooterContainerStyles = {
    logoGridItem: {
        width: 12,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList2GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            padding: 0;

            ${IconWrapper} {
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin: 0 ${pxToRem(7)};
                            `,
                            null,
                            css`
                                margin: 0 0 ${pxToRem(14)} ${pxToRem(14)};
                            `,
                        ],
                        mediaOptions.min,
                    )}
            }

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            text-align: center;
                            padding: 0 20%;

                            ${zoneNestedElementsSelector} {
                                display: flex;
                                justify-content: center;
                            }
                        `,
                        null,
                        css`
                            text-align: right;
                            padding: 0;

                            ${zoneNestedElementsSelector} {
                                justify-content: flex-end;
                            }

                            > div {
                                width: ${pxToRem(100)};
                                margin-left: auto;
                            }
                        `,
                        css`
                            > div {
                                width: 100%;
                                margin-left: 0;
                            }
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    footerContainer: {
        css: css`
            padding: ${pxToRem(16)};

            ${StyledClickable} {
                color: inherit;

                > ${StyledTypography} {
                    color: inherit;
                    font-weight: ${({ theme }) => theme.design.typography.weight.base};
                }

                &:hover {
                    text-decoration: underline;

                    > ${StyledTypography} {
                        color: inherit;
                    }
                }
            }

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            text-align: center;
                        `,
                        null,
                        css`
                            text-align: left;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },

    gridContainer: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smaller};
        `,
        offsetCss: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: column-reverse;
                        `,
                        null,
                        css`
                            flex-direction: row;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    leftGridItem: {
        width: [12, 12, 8, 8, 8],
        align: "middle",
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: ${pxToRem(15)};
                        `,
                        null,
                        css`
                            padding: ${pxToRem(10)} ${pxToRem(15)} ${pxToRem(12)};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    rightGridItem: {
        width: [12, 12, 4, 4, 4],
        align: "middle",
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: ${pxToRem(15)} ${pxToRem(15)} 0;
                            text-align: center;
                        `,
                        null,
                        css`
                            padding: ${pxToRem(10)} ${pxToRem(15)} ${pxToRem(12)};
                            text-align: right;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    bottomGridItem: {
        width: 12,
    },
    contactWrapper: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 80%;
                            margin: ${pxToRem(20)} auto;
                            padding-top: ${pxToRem(20)};
                            line-height: ${({ theme }) => theme.design.typography.lineHeight.small};
                        `,
                        null,
                        css`
                            width: 50%;
                            max-width: ${pxToRem(290)};
                            margin: ${pxToRem(20)} 0 0;
                            padding-top: ${pxToRem(25)};
                            line-height: ${({ theme }) => theme.design.typography.lineHeight.large};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    linkListGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            padding: 0;

            ${StyledClickable} {
                > ${StyledTypography} {
                    ${({ theme }) => `
                        font-weight: ${theme.design.typography.weight.bold};
                        line-height: ${theme.design.typography.lineHeight.small};
                    `}
                }
            }

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-bottom: ${pxToRem(55)};
                            text-align: center;

                            ${zoneNestedElementsSelector} {
                                text-align: center;
                            }
                        `,
                        null,
                        css`
                            padding-bottom: 0;

                            ${zoneNestedElementsSelector} {
                                text-align: left;
                            }
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({
    id,
    extendedStyles,
    // Starter Custom Code
    fields: { contentTitle, firstColumnTitle, secondColumnTitle, thirdColumnTitle, /* Store Custom Code */ fullWidth },
}) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));

    // Sas --->
    const containerStyles = css`
        ${styles?.footerContainer?.css}
        ${fullWidth
            ? css`
                  ${x => breakpointValues(x.theme.design.layout.spacing.side, ["padding-right", "padding-left"])}
              `
            : siteWidthStyles()}
    `;
    // <--- Sas
    /* Starter Custom Code - Start */
    const showLegalLeft = useZoneIsActive(id, "LegalLeft");
    const showLegalMiddle = useZoneIsActive(id, "LegalMiddle");
    const showLegalRight = useZoneIsActive(id, "LegalRight");

    return (
        // Store Custom Code - >
        <StyledWrapper css={containerStyles}>
            <GridContainer {...styles.gridContainer}>
                <GridItem {...styles.leftGridItem}>
                    <Zone zoneName="FooterLegalZone" contentId={id} />
                </GridItem>
                <GridItem {...styles.rightGridItem}>
                    <Zone zoneName="language" contentId={id} />
                </GridItem>
            </GridContainer>
        </StyledWrapper>
        //  <--- SasCustom  Code
    );
    /* Starter Custom Code - End */
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
        /* Starter Custom Code - Start */
        fieldDefinitions: [
            {
                name: fields.contentTitle,
                displayName: "Content title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.firstColumnTitle,
                displayName: "First Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "Translatable",
            },
            {
                name: fields.secondColumnTitle,
                displayName: "Second Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "Translatable",
            },
            {
                name: fields.thirdColumnTitle,
                displayName: "Third Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
                fieldType: "Translatable",
            },
            // Store Custom Code
            {
                name: fields.fullWidth,
                displayName: "Full width",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
        /* Starter Custom Code - End */
    },
};

export default footerContainer;
